var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighMoodLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 152,
    viewBox: "0 0 211 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.903 27.3076C154.353 36.1929 159.617 49.9023 160.842 63.5886C172.363 66.3397 187.791 79.0165 187.791 95.9086C187.791 117.925 164.949 128.244 156.18 128.221L49.1552 127.92C31.6312 127.874 18.4227 112.523 17.1049 95.8778C15.8796 80.3882 25.5587 68.4512 37.1412 60.4059C35.6693 50.5342 40.4163 42.5968 48.1611 38.1503C56.1756 33.5496 65.5541 32.8792 73.9385 38.3121C82.9933 25.9359 95.5699 17.8289 111.26 17.0583C122.064 16.5265 134.856 19.609 143.903 27.3076Z",
    fill: "url(#paint0_linear_5022_13992)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5022_13992",
    x1: 161.286,
    y1: 17,
    x2: 43.5047,
    y2: 128.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EEF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996158,
    stopColor: "#34B4C9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighMoodLeftIcon);
export default __webpack_public_path__ + "static/media/highMoodLeftIcon.c0b9767b581f08b3b842db6433d97c16.svg";
export { ForwardRef as ReactComponent };